module.exports = require('preact-css-transition-group');



//////////////////
// WEBPACK FOOTER
// ../~/preact-compat/lib/ReactCSSTransitionGroup.js
// module id = 46
// module chunks = 0